import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, Empty, Button, message, Modal, List } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { IMAGES, UPLOADS, FILES } from '../../../../params';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { TbReload } from "react-icons/tb";
SwiperCore.use([Autoplay, Navigation, Pagination]);

export const Item = props => {
    
    const dispatch = useDispatch();
    const app_global = useSelector(state => state.app_global);
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [activeModal, setActiveModal] = useState("");

    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [paginationSize, setPaginationSize] = useState(6);

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <Modal mask centered className="modal_portal" key="m1" width={1600} title="Укрепи свое здоровье за 30 минут в день" open={activeModal === 'health'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Укрепи свое здоровье за 30 минут в день</h2>
                        </div>
                        <div className='text_content'>
                            <p>Современный образ жизни часто связан с сидячей работой, малоподвижным образом жизни и недостаточной физической активностью. Это может привести к различным заболеваниям и проблемам со здоровьем. Однако, даже небольшие усилия в повседневной жизни могут существенно улучшить физическую форму и здоровье.</p>
                            <h3>Вот несколько простых способов, как поддерживать физическую активность в повседневной жизни, не напрягаясь:</h3>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: null,
                                            image: 'hls_image_01_06_03.jpeg',
                                            text: 'Поднимайтесь по лестнице вместо использования лифта: каждый раз, когда вы сталкиваетесь с выбором между лифтом и лестницей, выбирайте лестницу. Подъем по лестнице является отличной кардиотренировкой, укрепляет мышцы и увеличивает выносливость'
                                        },{
                                            title: null,
                                            image: 'hls_image_01_06_04.jpeg',
                                            text: 'Сделайте определенное количество шагов в день: старайтесь делать не менее 10 000 шагов в день. Это может быть легко достигнуто, если вы ходите по работе, делаете прогулки во время обеда или вечерней прогулки. Просто ставьте перед собой цель каждый день сделать не менее 10 000 шагов'
                                        },{
                                            title: null,
                                            image: 'hls_image_01_06_05.jpeg',
                                            text: 'Занимайтесь йогой или пилатесом: йога и пилатес - это замечательные упражнения, которые могут быть выполнены дома или в специальных залах. Они помогают укрепить мышцы, улучшить гибкость и осанку'
                                        },{
                                            title: null,
                                            image: 'hls_image_01_06_06.jpeg',
                                            text: 'Находите время на ежедневную прогулку: если у вас есть возможность сделать ежедневную прогулку, не упускайте ее. Это может быть утренняя или вечерняя прогулка, которая позволяет получить свежий воздух и привнести физическую активность в вашу жизнь'
                                        },
                                        {
                                            title: null,
                                            image: 'hls_image_01_06_07.jpeg',
                                            text: 'Используйте велосипед вместо автомобиля: если у вас есть возможность, используйте велосипед вместо автомобиля для коротких поездок. Это отличный способ улучшить физическую форму и сохранить здоровье'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} className='column' >
                                        <none />
                                        {item.image ? 
                                            <img src={`${IMAGES}/banners/${item.image}`} />
                                        :
                                            null
                                        }
                                        <div className='info'>  
                                            {item.title ? 
                                                <p className='title'>{item.title}</p>
                                            :
                                                null
                                            }
                                            <p className='text'>{item.text}</p>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/health.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <Modal mask centered className="modal_portal" key="m2" width={1600} title="Упражнения для мышц шеи" open={activeModal === 'health_1'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Упражнения для мышц шеи</h2>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: 'Наклоны головы',
                                            image: 'hls_image_01_07_03.jpeg',
                                            text: 'Сядьте прямо, поставьте ноги на ширине плеч. Наклоните голову вперед, пытаясь дотянуться подбородком к груди. Затем медленно наклоните голову назад, пытаясь посмотреть на потолок. Повторите 10 раз'
                                        },{
                                            title: 'Вращения головы',
                                            image: 'hls_image_01_07_04.jpeg',
                                            text: 'Возьмите гантели нужного веса, сядьте на стул и согните руки с гантелями в локтях, затем медленно выпрямите руки, напрягая трицепсы'
                                        },{
                                            title: 'Подъемы плеч',
                                            image: 'hls_image_01_07_05.jpeg',
                                            text: 'Сидя или стоя, положите руки на бедра. Поднимите плечи вверх, как можно выше, затем опустите их вниз. Повторите 10 раз'
                                        },{
                                            title: 'Упражнение с руками',
                                            image: 'hls_image_01_07_06.jpeg',
                                            text: 'Сядьте прямо, поставьте руки на затылок, ладонями наружу. Пытаясь сопротивляться руками, наклоните голову вперед, пытаясь дотянуться подбородком к груди. Затем медленно наклоните голову назад, пытаясь посмотреть на потолок. Повторите 10 раз'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} className='column' >
                                        <none />
                                        {item.image ? 
                                            <img src={`${IMAGES}/banners/${item.image}`} />
                                        :
                                            null
                                        }
                                        <div className='info'>  
                                            {item.title ? 
                                                <p className='title'>{item.title}</p>
                                            :
                                                null
                                            }
                                            <p className='text'>{item.text}</p>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/health_1.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <Modal mask centered className="modal_portal" key="m3" width={1600} title="Упражнения для мышц бицепса и трицепса" open={activeModal === 'health_2'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Упражнения для мышц бицепса и трицепса</h2>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: 'Отжимания',
                                            image: 'hls_image_01_07_07.jpeg',
                                            text: 'Обычные отжимания или отжимания на узкой опоре хорошо развивают трицепсы. Вы можете делать отжимания на полу или на подходящей для вас поверхности'
                                        },{
                                            title: 'Разгибание рук с гантелями',
                                            image: 'hls_image_01_07_08.jpeg',
                                            text: 'Возьмите гантели нужного веса, сядьте на стул и согните руки с гантелями в локтях, затем медленно выпрямите руки, напрягая трицепсы'
                                        },{
                                            title: 'Сгибание рук с гантелями',
                                            image: 'hls_image_01_07_09.jpeg',
                                            text: 'Возьмите гантели нужного веса и стойте прямо. Согните руки в локтях, поднимая гантели к плечам, напрягая бицепсы. Затем медленно опустите гантели'
                                        },{
                                            title: 'Кикбэки с гантелями',
                                            image: 'hls_image_01_07_10.jpeg',
                                            text: 'Возьмите гантели нужного веса, стойте на четвереньках, согните локти под углом 90 градусов и поднимите руки назад, напрягая трицепсы. Затем медленно вернитесь в исходное положение'
                                        },
                                        {
                                            title: 'Молотковый подъем гантелей',
                                            image: 'hls_image_01_07_11.jpeg',
                                            text: 'Возьмите гантели нужного веса и стойте прямо. Держите гантели вдоль тела с ладонями, направленными друг к другу. Согните руки в локтях, поднимая гантели к плечам, напрягая бицепсы. Затем медленно опустите гантели'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} className='column' >
                                        <none />
                                        {item.image ? 
                                            <img src={`${IMAGES}/banners/${item.image}`} />
                                        :
                                            null
                                        }
                                        <div className='info'>  
                                            {item.title ? 
                                                <p className='title'>{item.title}</p>
                                            :
                                                null
                                            }
                                            <p className='text'>{item.text}</p>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/health_2.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <Modal mask centered className="modal_portal" key="m4" width={1600} title="Упражнения для мышц спины" open={activeModal === 'health_3'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Упражнения для мышц спины</h2>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: 'Подтягивания на турнике',
                                            image: 'hls_image_01_07_12.jpeg',
                                            text: 'Возьмитесь руками за турник, возьмите хват шире плеч и подтянитесь, напрягая спинные мышцы. Если у вас нет турника, можно использовать любую подходящую высоту, например, перекладину гимнастической лестницы'
                                        },{
                                            title: 'Гиперэкстензия на полу',
                                            image: 'hls_image_01_07_13.jpeg',
                                            text: 'Лягте на пол лицом вниз, положите руки на затылок и поднимайте голову и верхнюю часть туловища вверх, напрягая спину'
                                        },{
                                            title: 'Подъем гантелей в наклоне',
                                            image: 'hls_image_01_07_14.jpeg',
                                            text: 'Возьмите гантели нужного веса и стойте в наклоне, держа их перед собой. Медленно поднимайте гантели к груди, напрягая спину, затем медленно опускайте их вниз'
                                        },{
                                            title: 'Разведение рук в стороны с гантелями',
                                            image: 'hls_image_01_07_15.jpeg',
                                            text: 'Возьмите гантели нужного веса, стойте прямо и разведите руки в стороны до уровня плеч, напрягая спинные мышцы. Затем медленно вернитесь в исходное положение'
                                        },
                                        {
                                            title: 'Повороты корпуса',
                                            image: 'hls_image_01_07_16.jpeg',
                                            text: 'Сядьте на стул или диван с прямой спиной и перекрестите руки на груди. Поверните корпус в одну сторону, напрягая спину, затем медленно вернитесь в исходное положение и поверните в другую сторону'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} className='column' >
                                        <none />
                                        {item.image ? 
                                            <img src={`${IMAGES}/banners/${item.image}`} />
                                        :
                                            null
                                        }
                                        <div className='info'>  
                                            {item.title ? 
                                                <p className='title'>{item.title}</p>
                                            :
                                                null
                                            }
                                            <p className='text'>{item.text}</p>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/health_3.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <Modal mask centered className="modal_portal" key="m5" width={1600} title="Упражнения для грудных мышц" open={activeModal === 'health_4'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Упражнения для грудных мышц</h2>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: 'Отжимания на полу',
                                            image: 'hls_image_01_07_17.jpeg',
                                            text: 'Классическое упражнение для грудных мышц. Лягте на пол, положите ладони на ширине плеч и выполняйте отжимания, опуская грудь к полу и поднимая тело вверх'
                                        },{
                                            title: 'Разведение рук с гантелями',
                                            image: 'hls_image_01_07_18.jpeg',
                                            text: 'Возьмите гантели нужного веса, лягте на пол и приподнимите их вверх. Разведите руки в стороны, затем медленно вернитесь в исходное положение.'
                                        },{
                                            title: 'Жим гантелей на полу',
                                            image: 'hls_image_01_07_19.jpeg',
                                            text: 'Возьмите гантели нужного веса, лягте на пол и поднимите гантели над собой. Медленно опустите гантели на уровень груди, затем вернитесь в исходное положение'
                                        },{
                                            title: 'Растяжка с резинкой',
                                            image: 'hls_image_01_07_20.jpeg',
                                            text: 'Возьмите резинку для тренировок и закрепите ее на уровне груди. Сделайте шаг вперед, чтобы создать натяжение на резинке. Затем растяните ее в стороны, чтобы работать с грудными мышцами'
                                        },
                                        {
                                            title: 'Одинаковые отжимания',
                                            image: 'hls_image_01_07_21.jpeg',
                                            text: 'Положите ладони на корпус стула или дивана на ширине плеч и выполняйте отжимания, опуская грудь к поверхности и поднимая тело вверх'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} className='column' >
                                        <none />
                                        {item.image ? 
                                            <img src={`${IMAGES}/banners/${item.image}`} />
                                        :
                                            null
                                        }
                                        <div className='info'>  
                                            {item.title ? 
                                                <p className='title'>{item.title}</p>
                                            :
                                                null
                                            }
                                            <p className='text'>{item.text}</p>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/health_4.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <Modal mask centered className="modal_portal" key="m6" width={1600} title="Упражнения для мышц ног" open={activeModal === 'health_5'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Упражнения для мышц ног</h2>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: 'Приседания',
                                            image: 'hls_image_01_07_22.jpeg',
                                            text: 'Приседания являются одним из лучших упражнений для ног. Вы можете делать классические приседания или приседания на одной ноге'
                                        },{
                                            title: 'Шаги на месте',
                                            image: 'hls_image_01_07_23.jpeg',
                                            text: 'Это простое упражнение, которое может улучшить кровообращение и сжигать жир в области ног. Вы можете делать обычные шаги на месте или добавить высокие колени для дополнительной интенсивности'
                                        },{
                                            title: 'Выпады',
                                            image: 'hls_image_01_07_24.jpeg',
                                            text: 'Выпады — это упражнение, которое помогает развивать мышцы ног и ягодиц. Вы можете делать выпады вперед или назад, используя свой вес тела или добавляя дополнительный вес с помощью'
                                        },{
                                            title: 'Наклоны назад',
                                            image: 'hls_image_01_07_25.jpeg',
                                            text: 'Это упражнение также называют "мостиком". Лягте на пол, согните колени и поставьте стопы на пол. Затем медленно поднимите бедра, напрягая ягодицы и ноги. Поддерживайте положение вверху на несколько секунд, затем медленно опускайтесь в исходное положение'
                                        },
                                        {
                                            title: 'Кикбоксинг',
                                            image: 'hls_image_01_07_26.jpeg',
                                            text: 'Кикбоксинг — это хорошая кардио-тренировка, которая также улучшает координацию и развивает мышцы ног. Вы можете делать удары в воздух или использовать мешок для более интенсивной тренировки'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} className='column' >
                                        <none />
                                        {item.image ? 
                                            <img src={`${IMAGES}/banners/${item.image}`} />
                                        :
                                            null
                                        }
                                        <div className='info'>  
                                            {item.title ? 
                                                <p className='title'>{item.title}</p>
                                            :
                                                null
                                            }
                                            <p className='text'>{item.text}</p>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/health_5.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <Modal mask centered className="modal_portal" key="m7" width={1600} title="Упражнения для мышц живота" open={activeModal === 'health_6'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Упражнения для мышц живота</h2>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: 'Пресс',
                                            image: 'hls_image_01_07_27.jpeg',
                                            text: 'Лёжа на спине, согните колени, поднимите плечи и верхнюю часть тела вверх, стараясь не напрягать шею. Напрягайте мышцы пресса и удерживайте позу на несколько секунд, затем медленно опускайтесь на пол'
                                        },{
                                            title: 'Планка',
                                            image: 'hls_image_01_07_28.jpeg',
                                            text: 'Лёжа на животе, поднимите тело на прямых руках и носках ног, удерживая прямую линию от головы до пяток. Напрягайте мышцы пресса и удерживайте позу на несколько секунд, затем медленно опускайтесь на пол'
                                        },{
                                            title: 'Боковая планка',
                                            image: 'hls_image_01_07_29.jpeg',
                                            text: 'Аналогично обычной планке, но с опорой на одну руку и бок. Напрягайте боковые мышцы пресса и удерживайте позу на несколько секунд, затем переворачивайтесь на другой бок и повторяйте'
                                        },{
                                            title: 'Велосипед',
                                            image: 'hls_image_01_07_30.jpeg',
                                            text: 'Лёжа на спине, поднимите ноги вверх, согните их в коленях и начните имитировать педалирование на велосипеде. При этом поднимайте плечи и верхнюю часть тела, напрягая мышцы пресса'
                                        },
                                        {
                                            title: 'Ножницы',
                                            image: 'hls_image_01_07_31.jpeg',
                                            text: 'лёжа на спине, поднимите ноги на высоту около 30 см и начните перекрещивать их, как при игре в "ножницы". При этом поднимайте плечи и верхнюю часть тела, напрягая мышцы пресса'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} className='column' >
                                        <none />
                                        {item.image ? 
                                            <img src={`${IMAGES}/banners/${item.image}`} />
                                        :
                                            null
                                        }
                                        <div className='info'>  
                                            {item.title ? 
                                                <p className='title'>{item.title}</p>
                                            :
                                                null
                                            }
                                            <p className='text'>{item.text}</p>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/health_6.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <section className='container_full --hls_item_7'>
                        <section className='top'>
                            <section className='container shadow default_padding'>
                                <h1>Группы мышц</h1>
                            </section>
                        </section>
                        <section className='body'>
                            <section className='container shadow default_padding'>
                                <section className='left'>
                                    <p className='title'>Рекомендуем ознакомиться</p>
                                    <p className='excerpt'>Прочитав статьи вы сможете качественно улучшить текущее состояние вашего здоровья.</p>
                                    <div className='slider_pc'>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый образ жизни</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Правильное питание</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Физическая активность</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый сон</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='slider_mob'>
                                        <Swiper
                                            loop
                                            spaceBetween={12}
                                            slidesPerView={1.5}
                                            pagination={{
                                                type: "progressbar",
                                            }}
                                            navigation={{
                                                prevEl: navigationPrevRef.current,
                                                nextEl: navigationNextRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                            }}
                                            breakpoints={{
                                                992: {
                                                    slidesPerView: 2.75,
                                                },
                                                991: {
                                                    slidesPerView: 2,
                                                },
                                                700: {
                                                    slidesPerView: 1.5,
                                                },
                                            }}
                                        >
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый образ жизни</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Правильное питание</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Физическая активность</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый сон</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        </Swiper>
                                    </div>
                                </section>
                                <section className='right'>
                                    <div className='content'>
                                        <div className='header'>
                                            <div className='posts_image_big'>
                                                <img src={`${IMAGES}/banners/hls_image_01_07_01.jpeg`} />
                                            </div>
                                        </div>

                                        <div className='body'>
                                            <div className='text_content'>
                                                <h3>Существует множество групп мышц в человеческом теле, для каждой из которых существуют специальные упражнения. Некоторые из этих групп мышц включают:</h3>
                                                <ul>
                                                    <li><none /><b>Грудные мышцы:</b> это мышцы, которые находятся на грудной клетке и отвечают за подъем и опускание рук, а также за вращение плечевых лопаток. Упражнения для грудных мышц включают отжимания, скамейку для жима, различные машины для жима</li>
                                                    <li><none /><b>Спина и трапеции:</b> эти мышцы находятся на верхней части спины и отвечают за движение плечей, головы и шеи. Упражнения для спины и трапеций включают подтягивания, различные виды жимов, лопаточный мостик, гиперэкстензию спины</li>
                                                    <li><none /><b>Бицепсы и трицепсы:</b> это мышцы на верхней части рук, которые отвечают за сгибание и разгибание локтей. Упражнения для бицепсов и трицепсов включают подъемы штанги, жимы, упражнения на тренажерах</li>
                                                    <li><none /><b>Ноги:</b> мышцы ног состоят из больших, средних и маленьких мышц, которые отвечают за движение и поддержание тела. Упражнения для ног включают приседания, жим ногами, различные упражнения на икры и бедра</li>
                                                    <li><none /><b>Живот:</b> мышцы живота включают прямую мышцу живота, внутреннюю и наружную косую мышцы. Они отвечают за движение тела, повороты и поддержание равновесия. Упражнения для живота включают скручивания, планку, подъемы ног</li>
                                                </ul>
                                                <p>Это лишь небольшой список групп мышц и упражнений, которые можно выполнять для их укрепления. Регулярная физическая активность и тренировки помогут улучшить форму тела и поддерживать здоровье мышечной ткани.</p>
                                            </div>
                                            <div className='exercises' style={{background:`url(${IMAGES}/banners/hls_image_01_07_02.jpeg)`}}>
                                                <div className='item' onClick={() => setActiveModal('health_1')}>
                                                    <p>Упражнения для мышц шеи</p>
                                                </div>
                                                <div className='item' onClick={() => setActiveModal('health_2')}>
                                                    <p>Упражнения для мышц бицепса и трицепса</p>
                                                </div>
                                                <div className='item' onClick={() => setActiveModal('health_3')}>
                                                    <p>Упражнения для мышц спины</p>
                                                </div>
                                                <div className='item' onClick={() => setActiveModal('health_4')}>
                                                    <p>Упражнения для грудных мышц</p>
                                                </div>
                                                <div className='item' onClick={() => setActiveModal('health_5')}>
                                                    <p>Упражнения для мышц ног</p>
                                                </div>
                                                <div className='item' onClick={() => setActiveModal('health_6')}>
                                                    <p>Упражнения для мышц живота</p>
                                                </div>
                                            </div>
                                            <div className="text_content">
                                                <p>Это лишь небольшой список групп мышц и упражнений, которые можно выполнять для их укрепления. Регулярная физическая активность и тренировки помогут улучшить форму тела и поддерживать здоровье мышечной ткани.</p>
                                            </div>
                                            <section className='container shadow default_padding next'>
                                                <div className='next_container' onClick={() => setActiveModal('health')}>
                                                    <div className='content full'>
                                                        <div className='list visible'>
                                                            <div className='item image_item'>
                                                                <div className='rotate' style={{background: `url(${IMAGES}/banners/hls_image_01_06_02.jpeg)`}}>

                                                                </div>
                                                            </div>
                                                            <div className='item text_item'>
                                                                <div className='rotate'>
                                                                    <p>Укрепи свое здоровье за 30 минут в день</p>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </section>
                </>
            }
        </>
    );
};